import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../ui/SuspenseWithCatch'
import SomethingWentWrong from '../ui/SomethingWentWrong'

import Loading from '../ui/Loading'
import { Bundles, loadBundle } from '../../util/moduleLoader'

const AuthCodeAsync = lazy(() => loadBundle(Bundles.Auth).then((bundle) => ({ default: bundle.AuthCode })))

const AuthCode = () => {
  return (
    <SuspenseWithCatch fallback={<SomethingWentWrong />} loading={<Loading />}>
      <AuthCodeAsync />
    </SuspenseWithCatch>
  )
}

export default memo(AuthCode)
